/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmPictureFragment } from './CMPicture.fragment';
import { CmVideoFragment } from './CMVideo.fragment';
import { CmLinkable_CmArticleImpl_Fragment, CmLinkable_CmAudioImpl_Fragment, CmLinkable_CmChannelImpl_Fragment, CmLinkable_CmCollectionImpl_Fragment, CmLinkable_CmDownloadImpl_Fragment, CmLinkable_CmDynamicListImpl_Fragment, CmLinkable_CmExternalLinkImpl_Fragment, CmLinkable_CmGalleryImpl_Fragment, CmLinkable_CmhtmlImpl_Fragment, CmLinkable_CmImageMapImpl_Fragment, CmLinkable_CmInteractiveImpl_Fragment, CmLinkable_CmLinkableImpl_Fragment, CmLinkable_CmLocTaxonomyImpl_Fragment, CmLinkable_CmMediaImpl_Fragment, CmLinkable_CmNavigationImpl_Fragment, CmLinkable_CmPersonImpl_Fragment, CmLinkable_CmPictureImpl_Fragment, CmLinkable_CmPlaceholderImpl_Fragment, CmLinkable_CmProductImpl_Fragment, CmLinkable_CmQueryListImpl_Fragment, CmLinkable_CmSelectionRulesImpl_Fragment, CmLinkable_CmSpinnerImpl_Fragment, CmLinkable_CmTaxonomyImpl_Fragment, CmLinkable_CmTeasableImpl_Fragment, CmLinkable_CmTeaserImpl_Fragment, CmLinkable_CmVideoImpl_Fragment, CmLinkable_CmVisualImpl_Fragment, CmLinkable_FormEditorImpl_Fragment, CmLinkable_SosAmountIncreaseFormImpl_Fragment, CmLinkable_SosAuthorImpl_Fragment, CmLinkable_SosChartImpl_Fragment, CmLinkable_SosContactImpl_Fragment, CmLinkable_SosDonationCardImpl_Fragment, CmLinkable_SosDonationCertificateImpl_Fragment, CmLinkable_SosDonationFormImpl_Fragment, CmLinkable_SosDonationProductImpl_Fragment, CmLinkable_SosDonationProgressImpl_Fragment, CmLinkable_SosDonationToolImpl_Fragment, CmLinkable_SosEventImpl_Fragment, CmLinkable_SosFilterTeaserImpl_Fragment, CmLinkable_SosInternalLinkImpl_Fragment, CmLinkable_SosJobTeaserImpl_Fragment, CmLinkable_SosLocationImpl_Fragment, CmLinkable_SosNewsImpl_Fragment, CmLinkable_SosNotificationImpl_Fragment, CmLinkable_SosOfferImpl_Fragment, CmLinkable_SosOrderFormImpl_Fragment, CmLinkable_SosOrganisationImpl_Fragment, CmLinkable_SosOverlayImpl_Fragment, CmLinkable_SosPressreleaseImpl_Fragment, CmLinkable_SosPublicationImpl_Fragment, CmLinkable_SosRedirectPageImpl_Fragment, CmLinkable_SosSpecialTopicCategoryImpl_Fragment, CmLinkable_SosSpecialTopicImpl_Fragment, CmLinkable_SosTeaserImpl_Fragment, CmLinkable_SosTextfragmentImpl_Fragment, CmLinkable_SosTooltipImpl_Fragment, CmLinkable_SosWimmelbildImpl_Fragment, CmLinkable_ViewTypeHeroCollection_Fragment } from './CMLinkable.fragment';
import { CmTaxonomy_CmLocTaxonomyImpl_Fragment, CmTaxonomy_CmTaxonomyImpl_Fragment, CmTaxonomy_SosLocationImpl_Fragment } from './CMTaxonomy.fragment';
import { CmAccordionItem_CmArticleImpl_Fragment, CmAccordionItem_CmAudioImpl_Fragment, CmAccordionItem_CmChannelImpl_Fragment, CmAccordionItem_CmCollectionImpl_Fragment, CmAccordionItem_CmDownloadImpl_Fragment, CmAccordionItem_CmDynamicListImpl_Fragment, CmAccordionItem_CmExternalLinkImpl_Fragment, CmAccordionItem_CmGalleryImpl_Fragment, CmAccordionItem_CmhtmlImpl_Fragment, CmAccordionItem_CmImageMapImpl_Fragment, CmAccordionItem_CmInteractiveImpl_Fragment, CmAccordionItem_CmLocTaxonomyImpl_Fragment, CmAccordionItem_CmMediaImpl_Fragment, CmAccordionItem_CmNavigationImpl_Fragment, CmAccordionItem_CmPersonImpl_Fragment, CmAccordionItem_CmPictureImpl_Fragment, CmAccordionItem_CmPlaceholderImpl_Fragment, CmAccordionItem_CmProductImpl_Fragment, CmAccordionItem_CmQueryListImpl_Fragment, CmAccordionItem_CmSelectionRulesImpl_Fragment, CmAccordionItem_CmSpinnerImpl_Fragment, CmAccordionItem_CmTaxonomyImpl_Fragment, CmAccordionItem_CmTeasableImpl_Fragment, CmAccordionItem_CmTeaserImpl_Fragment, CmAccordionItem_CmVideoImpl_Fragment, CmAccordionItem_CmVisualImpl_Fragment, CmAccordionItem_FormEditorImpl_Fragment, CmAccordionItem_SosAmountIncreaseFormImpl_Fragment, CmAccordionItem_SosAuthorImpl_Fragment, CmAccordionItem_SosChartImpl_Fragment, CmAccordionItem_SosContactImpl_Fragment, CmAccordionItem_SosDonationCardImpl_Fragment, CmAccordionItem_SosDonationCertificateImpl_Fragment, CmAccordionItem_SosDonationFormImpl_Fragment, CmAccordionItem_SosDonationProductImpl_Fragment, CmAccordionItem_SosDonationProgressImpl_Fragment, CmAccordionItem_SosDonationToolImpl_Fragment, CmAccordionItem_SosEventImpl_Fragment, CmAccordionItem_SosFilterTeaserImpl_Fragment, CmAccordionItem_SosInternalLinkImpl_Fragment, CmAccordionItem_SosJobTeaserImpl_Fragment, CmAccordionItem_SosLocationImpl_Fragment, CmAccordionItem_SosNewsImpl_Fragment, CmAccordionItem_SosNotificationImpl_Fragment, CmAccordionItem_SosOfferImpl_Fragment, CmAccordionItem_SosOrderFormImpl_Fragment, CmAccordionItem_SosOrganisationImpl_Fragment, CmAccordionItem_SosOverlayImpl_Fragment, CmAccordionItem_SosPressreleaseImpl_Fragment, CmAccordionItem_SosPublicationImpl_Fragment, CmAccordionItem_SosRedirectPageImpl_Fragment, CmAccordionItem_SosSpecialTopicCategoryImpl_Fragment, CmAccordionItem_SosSpecialTopicImpl_Fragment, CmAccordionItem_SosTeaserImpl_Fragment, CmAccordionItem_SosTextfragmentImpl_Fragment, CmAccordionItem_SosTooltipImpl_Fragment, CmAccordionItem_SosWimmelbildImpl_Fragment, CmAccordionItem_ViewTypeHeroCollection_Fragment } from './CMAccordionItem.fragment';
import { gql } from '@apollo/client';
import { CmPictureFragmentDoc } from './CMPicture.fragment';
import { CmVideoFragmentDoc } from './CMVideo.fragment';
import { CmLinkableFragmentDoc } from './CMLinkable.fragment';
import { CmTaxonomyFragmentDoc } from './CMTaxonomy.fragment';
import { CmAccordionItemFragmentDoc } from './CMAccordionItem.fragment';
export type CmAccordion_CmCollectionImpl_Fragment = { __typename?: 'CMCollectionImpl', id: string, title?: string | null, segment?: string | null, type: string, teaserTitle?: string | null, extDisplayedDate?: string | null, modificationDate: string, viewtype?: string | null, name: string, accordionSettings?: any | null, detailText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, navigationPath?: Array<{ __typename?: 'CMArticleImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMAudioImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMChannelImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMCollectionImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDownloadImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDynamicListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMExternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMGalleryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMHTMLImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMImageMapImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMInteractiveImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLinkableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLocTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMMediaImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMNavigationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPersonImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPictureImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPlaceholderImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMQueryListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSelectionRulesImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSpinnerImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeasableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVideoImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVisualImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'FormEditorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAmountIncreaseFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAuthorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSChartImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSContactImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCardImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCertificateImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProgressImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationToolImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSEventImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSFilterTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSInternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSJobTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSLocationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNewsImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNotificationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOfferImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrderFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrganisationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOverlayImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPressreleaseImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPublicationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSRedirectPageImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTextfragmentImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTooltipImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSWimmelbildImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'ViewTypeHeroCollection', id: string, segment?: string | null, title?: string | null } | null> | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, media?: Array<{ __typename?: 'CMAudioImpl' } | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMMediaImpl' } | (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | { __typename?: 'CMSpinnerImpl' } | (
    { __typename?: 'CMVideoImpl' }
    & CmVideoFragment
  ) | { __typename?: 'CMVisualImpl' } | { __typename?: 'SOSChartImpl' } | null> | null, teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkable_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkable_ViewTypeHeroCollection_Fragment
  ) | null, teaserText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, teaserOverlaySettings?: { __typename?: 'TeaserOverlaySettings', style?: any | null, enabled?: boolean | null, positionX?: number | null, positionY?: number | null, width?: number | null } | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmAccordionItem_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmAccordionItem_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmAccordionItem_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmAccordionItem_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmAccordionItem_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmAccordionItem_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmAccordionItem_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmAccordionItem_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmAccordionItem_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmAccordionItem_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmAccordionItem_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmAccordionItem_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmAccordionItem_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmAccordionItem_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmAccordionItem_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmAccordionItem_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmAccordionItem_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmAccordionItem_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmAccordionItem_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmAccordionItem_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmAccordionItem_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmAccordionItem_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmAccordionItem_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmAccordionItem_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmAccordionItem_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmAccordionItem_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmAccordionItem_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmAccordionItem_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmAccordionItem_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmAccordionItem_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmAccordionItem_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmAccordionItem_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmAccordionItem_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmAccordionItem_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmAccordionItem_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmAccordionItem_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmAccordionItem_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmAccordionItem_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmAccordionItem_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmAccordionItem_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmAccordionItem_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmAccordionItem_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmAccordionItem_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmAccordionItem_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmAccordionItem_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmAccordionItem_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmAccordionItem_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmAccordionItem_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmAccordionItem_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmAccordionItem_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmAccordionItem_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmAccordionItem_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmAccordionItem_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmAccordionItem_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmAccordionItem_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmAccordionItem_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmAccordionItem_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmAccordionItem_ViewTypeHeroCollection_Fragment
  ) | null> | null };

export type CmAccordion_CmDynamicListImpl_Fragment = { __typename?: 'CMDynamicListImpl', id: string, title?: string | null, segment?: string | null, type: string, teaserTitle?: string | null, extDisplayedDate?: string | null, modificationDate: string, viewtype?: string | null, name: string, accordionSettings?: any | null, detailText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, navigationPath?: Array<{ __typename?: 'CMArticleImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMAudioImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMChannelImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMCollectionImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDownloadImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDynamicListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMExternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMGalleryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMHTMLImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMImageMapImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMInteractiveImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLinkableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLocTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMMediaImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMNavigationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPersonImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPictureImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPlaceholderImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMQueryListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSelectionRulesImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSpinnerImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeasableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVideoImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVisualImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'FormEditorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAmountIncreaseFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAuthorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSChartImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSContactImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCardImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCertificateImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProgressImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationToolImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSEventImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSFilterTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSInternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSJobTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSLocationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNewsImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNotificationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOfferImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrderFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrganisationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOverlayImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPressreleaseImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPublicationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSRedirectPageImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTextfragmentImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTooltipImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSWimmelbildImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'ViewTypeHeroCollection', id: string, segment?: string | null, title?: string | null } | null> | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, media?: Array<{ __typename?: 'CMAudioImpl' } | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMMediaImpl' } | (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | { __typename?: 'CMSpinnerImpl' } | (
    { __typename?: 'CMVideoImpl' }
    & CmVideoFragment
  ) | { __typename?: 'CMVisualImpl' } | { __typename?: 'SOSChartImpl' } | null> | null, teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkable_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkable_ViewTypeHeroCollection_Fragment
  ) | null, teaserText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, teaserOverlaySettings?: { __typename?: 'TeaserOverlaySettings', style?: any | null, enabled?: boolean | null, positionX?: number | null, positionY?: number | null, width?: number | null } | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmAccordionItem_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmAccordionItem_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmAccordionItem_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmAccordionItem_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmAccordionItem_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmAccordionItem_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmAccordionItem_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmAccordionItem_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmAccordionItem_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmAccordionItem_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmAccordionItem_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmAccordionItem_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmAccordionItem_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmAccordionItem_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmAccordionItem_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmAccordionItem_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmAccordionItem_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmAccordionItem_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmAccordionItem_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmAccordionItem_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmAccordionItem_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmAccordionItem_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmAccordionItem_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmAccordionItem_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmAccordionItem_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmAccordionItem_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmAccordionItem_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmAccordionItem_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmAccordionItem_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmAccordionItem_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmAccordionItem_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmAccordionItem_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmAccordionItem_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmAccordionItem_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmAccordionItem_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmAccordionItem_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmAccordionItem_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmAccordionItem_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmAccordionItem_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmAccordionItem_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmAccordionItem_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmAccordionItem_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmAccordionItem_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmAccordionItem_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmAccordionItem_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmAccordionItem_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmAccordionItem_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmAccordionItem_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmAccordionItem_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmAccordionItem_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmAccordionItem_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmAccordionItem_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmAccordionItem_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmAccordionItem_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmAccordionItem_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmAccordionItem_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmAccordionItem_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmAccordionItem_ViewTypeHeroCollection_Fragment
  ) | null> | null };

export type CmAccordion_CmGalleryImpl_Fragment = { __typename?: 'CMGalleryImpl', id: string, title?: string | null, segment?: string | null, type: string, teaserTitle?: string | null, extDisplayedDate?: string | null, modificationDate: string, viewtype?: string | null, name: string, accordionSettings?: any | null, detailText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, navigationPath?: Array<{ __typename?: 'CMArticleImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMAudioImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMChannelImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMCollectionImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDownloadImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDynamicListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMExternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMGalleryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMHTMLImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMImageMapImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMInteractiveImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLinkableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLocTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMMediaImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMNavigationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPersonImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPictureImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPlaceholderImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMQueryListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSelectionRulesImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSpinnerImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeasableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVideoImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVisualImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'FormEditorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAmountIncreaseFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAuthorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSChartImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSContactImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCardImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCertificateImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProgressImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationToolImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSEventImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSFilterTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSInternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSJobTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSLocationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNewsImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNotificationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOfferImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrderFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrganisationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOverlayImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPressreleaseImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPublicationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSRedirectPageImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTextfragmentImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTooltipImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSWimmelbildImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'ViewTypeHeroCollection', id: string, segment?: string | null, title?: string | null } | null> | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, media?: Array<{ __typename?: 'CMAudioImpl' } | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMMediaImpl' } | (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | { __typename?: 'CMSpinnerImpl' } | (
    { __typename?: 'CMVideoImpl' }
    & CmVideoFragment
  ) | { __typename?: 'CMVisualImpl' } | { __typename?: 'SOSChartImpl' } | null> | null, teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkable_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkable_ViewTypeHeroCollection_Fragment
  ) | null, teaserText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, teaserOverlaySettings?: { __typename?: 'TeaserOverlaySettings', style?: any | null, enabled?: boolean | null, positionX?: number | null, positionY?: number | null, width?: number | null } | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmAccordionItem_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmAccordionItem_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmAccordionItem_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmAccordionItem_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmAccordionItem_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmAccordionItem_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmAccordionItem_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmAccordionItem_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmAccordionItem_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmAccordionItem_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmAccordionItem_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmAccordionItem_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmAccordionItem_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmAccordionItem_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmAccordionItem_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmAccordionItem_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmAccordionItem_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmAccordionItem_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmAccordionItem_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmAccordionItem_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmAccordionItem_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmAccordionItem_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmAccordionItem_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmAccordionItem_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmAccordionItem_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmAccordionItem_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmAccordionItem_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmAccordionItem_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmAccordionItem_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmAccordionItem_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmAccordionItem_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmAccordionItem_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmAccordionItem_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmAccordionItem_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmAccordionItem_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmAccordionItem_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmAccordionItem_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmAccordionItem_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmAccordionItem_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmAccordionItem_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmAccordionItem_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmAccordionItem_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmAccordionItem_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmAccordionItem_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmAccordionItem_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmAccordionItem_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmAccordionItem_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmAccordionItem_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmAccordionItem_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmAccordionItem_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmAccordionItem_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmAccordionItem_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmAccordionItem_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmAccordionItem_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmAccordionItem_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmAccordionItem_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmAccordionItem_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmAccordionItem_ViewTypeHeroCollection_Fragment
  ) | null> | null };

export type CmAccordion_CmQueryListImpl_Fragment = { __typename?: 'CMQueryListImpl', id: string, title?: string | null, segment?: string | null, type: string, teaserTitle?: string | null, extDisplayedDate?: string | null, modificationDate: string, viewtype?: string | null, name: string, accordionSettings?: any | null, detailText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, navigationPath?: Array<{ __typename?: 'CMArticleImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMAudioImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMChannelImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMCollectionImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDownloadImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDynamicListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMExternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMGalleryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMHTMLImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMImageMapImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMInteractiveImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLinkableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLocTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMMediaImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMNavigationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPersonImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPictureImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPlaceholderImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMQueryListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSelectionRulesImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSpinnerImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeasableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVideoImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVisualImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'FormEditorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAmountIncreaseFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAuthorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSChartImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSContactImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCardImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCertificateImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProgressImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationToolImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSEventImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSFilterTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSInternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSJobTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSLocationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNewsImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNotificationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOfferImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrderFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrganisationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOverlayImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPressreleaseImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPublicationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSRedirectPageImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTextfragmentImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTooltipImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSWimmelbildImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'ViewTypeHeroCollection', id: string, segment?: string | null, title?: string | null } | null> | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, media?: Array<{ __typename?: 'CMAudioImpl' } | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMMediaImpl' } | (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | { __typename?: 'CMSpinnerImpl' } | (
    { __typename?: 'CMVideoImpl' }
    & CmVideoFragment
  ) | { __typename?: 'CMVisualImpl' } | { __typename?: 'SOSChartImpl' } | null> | null, teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkable_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkable_ViewTypeHeroCollection_Fragment
  ) | null, teaserText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, teaserOverlaySettings?: { __typename?: 'TeaserOverlaySettings', style?: any | null, enabled?: boolean | null, positionX?: number | null, positionY?: number | null, width?: number | null } | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmAccordionItem_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmAccordionItem_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmAccordionItem_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmAccordionItem_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmAccordionItem_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmAccordionItem_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmAccordionItem_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmAccordionItem_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmAccordionItem_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmAccordionItem_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmAccordionItem_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmAccordionItem_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmAccordionItem_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmAccordionItem_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmAccordionItem_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmAccordionItem_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmAccordionItem_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmAccordionItem_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmAccordionItem_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmAccordionItem_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmAccordionItem_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmAccordionItem_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmAccordionItem_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmAccordionItem_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmAccordionItem_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmAccordionItem_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmAccordionItem_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmAccordionItem_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmAccordionItem_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmAccordionItem_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmAccordionItem_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmAccordionItem_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmAccordionItem_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmAccordionItem_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmAccordionItem_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmAccordionItem_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmAccordionItem_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmAccordionItem_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmAccordionItem_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmAccordionItem_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmAccordionItem_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmAccordionItem_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmAccordionItem_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmAccordionItem_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmAccordionItem_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmAccordionItem_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmAccordionItem_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmAccordionItem_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmAccordionItem_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmAccordionItem_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmAccordionItem_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmAccordionItem_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmAccordionItem_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmAccordionItem_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmAccordionItem_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmAccordionItem_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmAccordionItem_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmAccordionItem_ViewTypeHeroCollection_Fragment
  ) | null> | null };

export type CmAccordion_CmSelectionRulesImpl_Fragment = { __typename?: 'CMSelectionRulesImpl', id: string, title?: string | null, segment?: string | null, type: string, teaserTitle?: string | null, extDisplayedDate?: string | null, modificationDate: string, viewtype?: string | null, name: string, accordionSettings?: any | null, detailText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, navigationPath?: Array<{ __typename?: 'CMArticleImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMAudioImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMChannelImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMCollectionImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDownloadImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDynamicListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMExternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMGalleryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMHTMLImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMImageMapImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMInteractiveImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLinkableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLocTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMMediaImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMNavigationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPersonImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPictureImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPlaceholderImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMQueryListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSelectionRulesImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSpinnerImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeasableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVideoImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVisualImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'FormEditorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAmountIncreaseFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAuthorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSChartImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSContactImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCardImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCertificateImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProgressImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationToolImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSEventImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSFilterTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSInternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSJobTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSLocationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNewsImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNotificationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOfferImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrderFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrganisationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOverlayImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPressreleaseImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPublicationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSRedirectPageImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTextfragmentImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTooltipImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSWimmelbildImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'ViewTypeHeroCollection', id: string, segment?: string | null, title?: string | null } | null> | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, media?: Array<{ __typename?: 'CMAudioImpl' } | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMMediaImpl' } | (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | { __typename?: 'CMSpinnerImpl' } | (
    { __typename?: 'CMVideoImpl' }
    & CmVideoFragment
  ) | { __typename?: 'CMVisualImpl' } | { __typename?: 'SOSChartImpl' } | null> | null, teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkable_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkable_ViewTypeHeroCollection_Fragment
  ) | null, teaserText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, teaserOverlaySettings?: { __typename?: 'TeaserOverlaySettings', style?: any | null, enabled?: boolean | null, positionX?: number | null, positionY?: number | null, width?: number | null } | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmAccordionItem_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmAccordionItem_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmAccordionItem_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmAccordionItem_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmAccordionItem_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmAccordionItem_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmAccordionItem_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmAccordionItem_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmAccordionItem_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmAccordionItem_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmAccordionItem_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmAccordionItem_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmAccordionItem_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmAccordionItem_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmAccordionItem_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmAccordionItem_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmAccordionItem_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmAccordionItem_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmAccordionItem_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmAccordionItem_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmAccordionItem_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmAccordionItem_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmAccordionItem_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmAccordionItem_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmAccordionItem_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmAccordionItem_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmAccordionItem_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmAccordionItem_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmAccordionItem_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmAccordionItem_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmAccordionItem_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmAccordionItem_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmAccordionItem_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmAccordionItem_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmAccordionItem_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmAccordionItem_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmAccordionItem_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmAccordionItem_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmAccordionItem_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmAccordionItem_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmAccordionItem_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmAccordionItem_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmAccordionItem_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmAccordionItem_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmAccordionItem_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmAccordionItem_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmAccordionItem_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmAccordionItem_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmAccordionItem_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmAccordionItem_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmAccordionItem_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmAccordionItem_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmAccordionItem_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmAccordionItem_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmAccordionItem_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmAccordionItem_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmAccordionItem_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmAccordionItem_ViewTypeHeroCollection_Fragment
  ) | null> | null };

export type CmAccordion_ViewTypeHeroCollection_Fragment = { __typename?: 'ViewTypeHeroCollection', id: string, title?: string | null, segment?: string | null, type: string, teaserTitle?: string | null, extDisplayedDate?: string | null, modificationDate: string, viewtype?: string | null, name: string, accordionSettings?: any | null, detailText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, navigationPath?: Array<{ __typename?: 'CMArticleImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMAudioImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMChannelImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMCollectionImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDownloadImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMDynamicListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMExternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMGalleryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMHTMLImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMImageMapImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMInteractiveImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLinkableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMLocTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMMediaImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMNavigationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPersonImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPictureImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMPlaceholderImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMQueryListImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSelectionRulesImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMSpinnerImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTaxonomyImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeasableImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVideoImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'CMVisualImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'FormEditorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAmountIncreaseFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSAuthorImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSChartImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSContactImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCardImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationCertificateImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProductImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationProgressImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSDonationToolImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSEventImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSFilterTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSInternalLinkImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSJobTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSLocationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNewsImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSNotificationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOfferImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrderFormImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOrganisationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSOverlayImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPressreleaseImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSPublicationImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSRedirectPageImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSSpecialTopicImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTeaserImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTextfragmentImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSTooltipImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'SOSWimmelbildImpl', id: string, segment?: string | null, title?: string | null } | { __typename?: 'ViewTypeHeroCollection', id: string, segment?: string | null, title?: string | null } | null> | null, picture?: (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | null, media?: Array<{ __typename?: 'CMAudioImpl' } | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMMediaImpl' } | (
    { __typename?: 'CMPictureImpl' }
    & CmPictureFragment
  ) | { __typename?: 'CMSpinnerImpl' } | (
    { __typename?: 'CMVideoImpl' }
    & CmVideoFragment
  ) | { __typename?: 'CMVisualImpl' } | { __typename?: 'SOSChartImpl' } | null> | null, teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkable_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkable_ViewTypeHeroCollection_Fragment
  ) | null, teaserText?: { __typename?: 'RichText', text?: string | null, textAsTree?: any | null } | null, teaserOverlaySettings?: { __typename?: 'TeaserOverlaySettings', style?: any | null, enabled?: boolean | null, positionX?: number | null, positionY?: number | null, width?: number | null } | null, subjectTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmAccordionItem_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmAccordionItem_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmAccordionItem_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmAccordionItem_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmAccordionItem_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmAccordionItem_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmAccordionItem_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmAccordionItem_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmAccordionItem_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmAccordionItem_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmAccordionItem_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmAccordionItem_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmAccordionItem_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmAccordionItem_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmAccordionItem_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmAccordionItem_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmAccordionItem_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmAccordionItem_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmAccordionItem_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmAccordionItem_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmAccordionItem_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmAccordionItem_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmAccordionItem_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmAccordionItem_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmAccordionItem_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmAccordionItem_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmAccordionItem_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmAccordionItem_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmAccordionItem_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmAccordionItem_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmAccordionItem_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmAccordionItem_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmAccordionItem_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmAccordionItem_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmAccordionItem_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmAccordionItem_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmAccordionItem_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmAccordionItem_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmAccordionItem_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmAccordionItem_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmAccordionItem_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmAccordionItem_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmAccordionItem_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmAccordionItem_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmAccordionItem_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmAccordionItem_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmAccordionItem_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmAccordionItem_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmAccordionItem_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmAccordionItem_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmAccordionItem_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmAccordionItem_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmAccordionItem_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmAccordionItem_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmAccordionItem_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmAccordionItem_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmAccordionItem_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmAccordionItem_ViewTypeHeroCollection_Fragment
  ) | null> | null };

export type CmAccordionFragment = CmAccordion_CmCollectionImpl_Fragment | CmAccordion_CmDynamicListImpl_Fragment | CmAccordion_CmGalleryImpl_Fragment | CmAccordion_CmQueryListImpl_Fragment | CmAccordion_CmSelectionRulesImpl_Fragment | CmAccordion_ViewTypeHeroCollection_Fragment;

export const CmAccordionFragmentDoc = gql`
    fragment CMAccordion on CMCollection {
  id
  title
  segment
  detailText {
    text
    textAsTree
  }
  type
  navigationPath {
    id
    segment
    title
  }
  picture {
    ...CMPicture
  }
  media {
    ...CMPicture
    ...CMVideo
  }
  teaserTarget {
    ...CMLinkable
  }
  teaserTitle
  teaserText {
    text
    textAsTree
  }
  teaserOverlaySettings {
    ... on TeaserOverlaySettings {
      style
      enabled
      positionX
      positionY
      width
    }
  }
  extDisplayedDate
  modificationDate
  subjectTaxonomy {
    ...CMTaxonomy
  }
  viewtype
  name
  items {
    ...CMAccordionItem
  }
  accordionSettings: settings(paths: ["accordionOpen"])
}
    ${CmPictureFragmentDoc}
${CmVideoFragmentDoc}
${CmLinkableFragmentDoc}
${CmTaxonomyFragmentDoc}
${CmAccordionItemFragmentDoc}`;